<script setup lang="ts">
import { toRefs } from 'vue';

const { t } = useLocale();

interface FaqModel {
  faq: { q: string, a: string }[],
  type: 'mobile' | 'resident' | 'corporate',
}

const props = defineProps<FaqModel>();

const { faq } = toRefs(props);
</script>

<template>
  <div class="proxy-faq" :class="type">
    <h2 class="sx-landing-title">
      {{ t('Часто задаваемые вопросы') }}
    </h2>

    <div class="proxy-faq__content">
      <el-collapse accordion>
        <el-collapse-item
          v-for="(item, index) in faq"
          :key="index" :title="t(item.q)"
          :name="index + 1"
        >
          <div class="proxy-faq__answer">
            {{ t(item.a) }}
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.proxy-faq {
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: center;
  font-family: AlsHauss, sans-serif;
  padding-top: 158px;
  height: fit-content;
  padding-bottom: 128px;

  :deep(.el-collapse-item__header) {
    height: auto !important;
    color: #000 !important;
    font-family: AlsHauss, sans-serif;
  }

  @media (width < 1040px) {
    height: auto !important;

    :deep(.el-collapse-item__header) {
      font-size: 20px !important;
      line-height: 24px !important;
    }
  }

  :deep(.el-collapse-item__content) {
    padding-bottom: 0 !important;
  }

  &__content {
    max-width: 1200px;
    width: 100%;
  }

  &__answer {
    padding: 32px;
    background: #fbfbfb;
    border-radius: 0 0 8px 8px;
    margin-top: -10px;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    text-align: left;
  }

  :deep(.el-collapse) {
    display: flex;
    flex-direction: column;
    gap: 32px;
    border: none;
  }

  &.resident {
    :deep(.el-collapse) {
      svg path {
        fill: #F6BAC8
      }
    }

    :deep(.el-collapse-item__header) {
      border-left: 4px solid #F6BAC8;
    }
  }

  &.corporate {
    :deep(.el-collapse) {
      svg path {
        fill: #FFCE9D
      }
    }

    :deep(.el-collapse-item__header) {
      border-left: 4px solid #FFCE9D;
    }
  }

  &.mobile {
    :deep(.el-collapse) {
      svg path {
        fill: #ADD2FF
      }
    }

    :deep(.el-collapse-item__header) {
      border-left: 4px solid #ADD2FF;
    }
  }

  :deep(.el-collapse-item__header) {
    border: none;
    padding: 24px 32px;
    font-size: 20px;
    font-weight: 500;
    line-height: 16px;
    border-radius: 8px;
    box-shadow: 0 4px 16px 0 #0000001A;
    position: relative;
    z-index: 10;
  }

  :deep(.el-collapse-item__wrap) {
    border: none;
  }
}

@media (max-width: 999px) {
  .proxy-faq {
    text-align: center;

    &__title {
      font-size: 48px;
      line-height: 48px;
    }
  }
}

@media (max-width: 699px) {
  .proxy-faq {
    &__title {
      font-size: 36px;
      line-height: 34px;
    }
  }
}

@media (max-width: 600px) {
  .proxy-faq {
    padding-bottom: 4rem;
    padding-top: 3rem;
    :deep(.el-collapse-item__header) {
      font-size: 16px !important;
      padding: 1rem;
      gap: .5rem
    }
    &__answer {
      padding: 1rem;
    }
  }
}
</style>
